import React from "react"
import tw, { styled } from "twin.macro"

import { withSubscribe } from "./withSubscribe"

import { StyledButton } from "../Styled/Button"
import { StyledH2 } from "../Styled/Text"
import { Icon } from "../Icon/Icon"

const Email = tw.form`
  flex items-center justify-between border border-dark rounded-1 w-30 md:w-full max-w-full
`
const Input = styled.input`
  ${tw`w-full text-16 px-1 h-4 md:h-4 leading-1 rounded-1 outline-none focus:outline-none bg-transparent placeholder-dark`}
  ${({ popup }) => (popup ? tw`bg-lightest` : tw``)}
`
//h-3-2 input
// const Button = tw(StyledButton)`border-l border-t-0 border-r-0 border-b-0 h-3-2 md:h-4`
const Button = tw(StyledButton)`border-0 outline-none h-4 md:h-4 shadow-none`

const Error = tw.div`
  text-16 mt-1 text-punch font-medium
`
const StyledIcon = tw(Icon)`cursor-pointer`

export const Subscribe = withSubscribe(
  ({ data, handleChange, handleSubmit, loading, popup, errors, success, placeholder, successMessage }): JSX.Element =>
    !success ? (
      <>
        <Email onSubmit={handleSubmit}>
          <Input name="email" type="email" value={data?.email} onChange={handleChange} placeholder={placeholder || `Your email`} popup={popup} />
          {/* <Button type={`submit`} disabled={loading} layout={`primary`} textsize={`lg-tight`} colour={`transparent`} background={`transparent`}>
            {`Go!`}
          </Button> */}
          <Button type={`submit`} disabled={loading} layout={`primary`} textsize={`lg-tight`} background={`transparent`}>
            <StyledIcon name={`rightArrow`} size={24} />
          </Button>
        </Email>
        {errors && <Error>{errors === "Email has already been taken" ? "This email address is already subscribed." : errors}</Error>}
      </>
    ) : (
      <StyledH2>{successMessage}</StyledH2>
    )
)
